<template>
  <div class="member-main">
    <ul class="title">
      <li class="active">绑定手机号</li>
    </ul>
    <!-- 个人忘记秘密 -->
    <el-form :model="form" :rules="formRules" ref="form">
      <el-form-item prop="phone">
        <el-select v-model="phoneCode" class="phone-areacode">
          <el-option
            v-for="(item, index) in phoneCodeList"
            :key="index"
            :label="`+${item.code}`"
            :value="`+${item.code}`"
          >
            <span style="float: left">{{ item.name }}</span>
            <span
              style="float: right; padding-left: 20px; color: #8492a6; font-size: 13px"
            >+{{ item.code }}</span>
          </el-option>
        </el-select>
        <el-input type="tel" v-model="form.phone" placeholder="手机号" class="phone-input"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="imageVerifyCode" placeholder="图形验证码" class="image-code-input"></el-input>
        <img
          :src="imageCodeUrl"
          class="image-code"
          alt="点击切换验证码"
          title="点击切换验证码"
          @click="changeImageCode"
        >
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-input
          type="number"
          v-model="form.verifyCode"
          placeholder="验证码"
          class="phone-code-input"
        ></el-input>
        <timer-button @click.native="onSendCode" ref="phoneCode"></timer-button>
        <!-- <el-button type="primary" class="phone-code-btn" @click="onSendCode">发送验证码</el-button> -->
      </el-form-item>
      <el-form-item>
        <el-button class="btn-block" type="primary" @click="SNSLogin">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import {
  getPhoneCode,
  getImageCode,
  sendCode,
  thirdRegister,
  getShareAppToken
} from '@/api/zaiart'
import TimerButton from '../common/timerButton'

export default {
  components: { TimerButton },
  data: () => ({
    phoneCodeList: [],
    phoneCode: '+86',
    sessionId: '',
    imageCodeUrl: '',
    imageVerifyCode: '',
    form: { phone: '', verifyCode: '', code: '', loginType: '' },
    formRules: {
      phone: { required: true, message: '请输入手机号', trigger: 'blur' },
      verifyCode: { required: true, message: '请输入验证码', trigger: 'blur' }
    }
  }),
  methods: {
    // 初始化
    init() {
      this.getPhoneCode()
      this.changeImageCode()
    },
    // 获取手机区号
    getPhoneCode() {
      return getPhoneCode().then(response => {
        this.phoneCodeList = response.data.countries
      })
    },
    // 切换图形验证码
    changeImageCode() {
      this.sessionId = Math.random()
        .toString(36)
        .substr(2)
      this.imageCodeUrl = getImageCode(this.sessionId)
    },
    // 发送验证码
    onSendCode() {
      let param = {
        sessionId: this.sessionId,
        imageVerifyCode: this.imageVerifyCode,
        account: this.phoneCode + ' ' + this.form.phone,
        sendFuncType: 'THIRD_LOGIN_BIND_PHONE'
      }
      if (!this.form.phone) {
        this.$message.error('请输入手机号')
        return false
      } else if (!param.imageVerifyCode) {
        this.$message.error('请输入图形验证码')
        return false
      }

      this.$refs.phoneCode.start()
      sendCode(param)
        .then(response => {
          this.$message({
            type: 'success',
            message: '验证码已发送，请查收'
          })
        })
        .catch(() => {
          this.$refs.phoneCode.stop()
        })
    },
    // 第三方注册
    SNSLogin() {
      let isPass = true
      // 表单验证
      this.$refs.form.validate(valid => {
        if (!valid) {
          isPass = false
          return false
        }
      })
      // 验证未通过
      if (!isPass) {
        return false
      }
      let param = JSON.parse(JSON.stringify(this.form))
      param.phone = `${this.phoneCode} ${param.phone}`
      param.utmSource = location.href
      return thirdRegister(param).then(response => {
        if (response.code === 1) {
          let data = response.data
          // 数据存储
          localStorage.setItem('token', data.token)
          localStorage.setItem('uid', data.uid)
          localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
          // 设置shareApp Token
          this.setShareAppToken()
          // 跳转
          this.$router.push({ path: '/', query: { uid: data.uid } })
        }
      })
    },
    setShareAppToken() {
      getShareAppToken().then(response => {
        Cookies.set('token', response.data.token, {
          domain: process.env.VUE_APP_COOKIES_DOMAIN,
          expires: 365
        })
      })
    }
  },
  created() {
    let query = this.$route.query
    if (query.type) {
      this.form.code = query.code
      this.form.loginType = query.type
    }
    this.init()
  }
}
</script>
